import * as Yup from 'yup'

const menuUrlSchema = Yup.object().shape({
  url: Yup.string()
    .url('Menu URL is not valid')
    .required('Menu URL is required'),
})

export default menuUrlSchema
